<div class="d-flex align-items-center">
    <mat-slide-toggle class="mat-slide-toggle-sm"></mat-slide-toggle>
    <span class="ml-2" (click)=open()>15</span>
</div>